export default "__VITE_ASSET__BBvuNhfJ__"